// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
//MD5加密
import md5 from 'js-md5';
import VueCookie from 'vue-cookies';
import VirtualScroll from 'el-table-virtual-scroll';
//全局引入自定义组件
import '@/assets/css/reset.css';
import router from './router';
import store from './store';
import i18n from './i18n';
import bootstrap from './core';
import Http from './plugins/http.js';
import cusInstall from './plugins/cus-component';
import VueMeta from 'vue-meta';

import './router/permission';
import './utils/filter';
// 引用api文件
// import api from './api/index';
// Vue.prototype.$api = api;
import outToExcel from './utils/outToExcel';
import axios from 'axios';
import directives from '@/utils/directives';
// import './utils/element';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true,
  contentSecurityPolicy: {
    defaultSrc: ["'self'"],
    scriptSrc: ["'self'", "'unsafe-inline'"],
    styleSrc: ["'self'", "'unsafe-inline'"],
    imgSrc: ["'self'"],
    connectSrc: ["'self'"],
    fontSrc: ["'self'"],
    objectSrc: ["'none'"],
    mediaSrc: ["'self'"]
  }
});
Vue.prototype.outToExcels = outToExcel;
Vue.prototype.$http = Http;
Vue.prototype.$md5 = md5;
Vue.prototype.$defaultPaginationSize = 100;
Vue.prototype.keys = {
  current_user: {
    token: 'token',
    user: 'user',
    menus: []
  }
};
Vue.prototype.$getStatus = (list, code) => {
  if (!list) return '';
  let az = list.filter((it) => it.value == code);
  let [item] = az;
  return item ? item.label : '';
};
Vue.prototype.$axios = axios;
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(ElementUI);
Vue.use(cusInstall);
Vue.use(VueCookie);
Vue.use(VirtualScroll);
Vue.component('virtual-scroll', VirtualScroll);

// Vue.use(MyServerHttp);
Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}

//根据不同域名 设置网页图标和标题
function setFaviconAndTitle(domain) {
  const link = document.querySelector("link[rel~='icon']");

  // 创建一个新的 link 元素
  const newLink = document.createElement('link');
  newLink.rel = 'icon';
  if (domain.includes('N1pay') || domain.includes('n1pay') || domain.includes('n1')) {
    document.title = 'N1pay';
    newLink.href = `/static/n1pay.jpg`; // 根据域名设置不同的图标路径
  } else if (domain.includes('gopay') || domain.includes('Gopay') || domain.includes('go')) {
    document.title = 'GoPay';
    newLink.href = `/static/gopay.svg`; // 根据域名设置不同的图标路径
  } else if (domain.includes('fastpay') || domain.includes('FastPay') || domain.includes('fast')) {
    document.title = 'FastPay';
    newLink.href = `/static/fastpay.ico`; // 根据域名设置不同的图标路径
  } else {
    document.title = 'Bwpay';
    newLink.href = `/static/fac.ico`; // 根据域名设置不同的图标路径
  }

  // 如果已经存在 link 元素，则替换为新的图标
  if (link) {
    document.head.removeChild(link); // 先移除旧的 link 元素
  }

  // 添加新的 link 元素到 head 中
  document.head.appendChild(newLink);
}
// 在 Vue 实例化之前执行设置网页图标和标题的方法
const currentDomain = window.location.hostname;
setFaviconAndTitle(currentDomain);

// 注册全局指令
Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key]);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  created: bootstrap,
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js